import { render, staticRenderFns } from "./ProgressIcon.vue?vue&type=template&id=81d32b4e&"
import script from "./ProgressIcon.vue?vue&type=script&lang=js&"
export * from "./ProgressIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports